import { type UserRole, canModerate } from './user-role';

// Records shown in the Praises & Feedback feed. Each type lives in its own table.
export const INTERACTION_TYPES = {
  PRAISE: 'praise',
  DIRECT_FEEDBACK: 'direct_feedback',
} as const;

export type InteractionType = (typeof INTERACTION_TYPES)[keyof typeof INTERACTION_TYPES];

export const INTERACTION_TYPE_VALUES = Object.values(INTERACTION_TYPES) as [InteractionType, ...InteractionType[]];

// Measured on the stored markdown. Legacy bodies merged from the four SBI+R sections may exceed it.
export const DIRECT_FEEDBACK_BODY_MAX = 10_000;

/** Praises and direct feedback are private to their sender and receiver; moderators see every record. */
export const canViewInteraction = (
  viewer: { id: string; role: UserRole },
  record: { createdBy: string; receiver: string },
): boolean => canModerate(viewer.role) || record.createdBy === viewer.id || record.receiver === viewer.id;
